/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./refreshIdentity.defs.js";
export { main as default } from "./refreshIdentity.defs.js";
